<template>
  <div>
    <div class="asc-fleet-messages-export">
      <div class="asc-fleet-messages-export-options--container">
        <div class="asc-fleet-messages-export-options">
          <asc-label
            class="asc-fleet-messages-export--label"
            size="md"
            value="Choose a date range of up to 1 year to export."
          ></asc-label>
          <div class="asc-empty-div"></div>
          <asc-date-picker
            v-model="dates"
            label="Dates"
            range-only
            has-icon
            :max="maxDate"
            :max-days="365"
            hide-details
            class="asc-child-options"
            icon-position="right"
            @input="handleInput()"
          ></asc-date-picker>
          <div class="asc-empty-div"></div>
          <asc-autocomplete-selector
            v-model="airlineIds"
            :items="airlinesData"
            label="Airline"
            class="asc-child-options"
            placeholder="Select Airline"
            :component-type="airlinesData.length > 1 ? 'multiple' : 'single'"
            dense
            drop-down-size-matches
            required
            fixed-position
            short
            @input="handleInput()"
          ></asc-autocomplete-selector>
          <div class="asc-empty-div"></div>
          <asc-autocomplete-selector
            v-model="ataChapterIds"
            :items="ataChaptersData"
            label="ATA Chapter"
            class="asc-child-options"
            placeholder="Select ATA Chapter"
            component-type="multiple"
            no-array
            dense
            drop-down-size-matches
            required
            fixed-position
            short
            @input="handleInput()"
          ></asc-autocomplete-selector>
          <div class="asc-empty-div"></div>
        </div>

        <asc-note class="asc-report-note">
          <v-icon class="asc-report-note--icon" :size="12" color="#C98703"
            >mdi-alert</v-icon
          >
          <span class="asc-report-note--text"
            >Note: Selected options will influence the amount of exported data
            and the time to generate the export.</span
          >
        </asc-note>
      </div>
    </div>
  </div>
</template>

<script>
import AscDatePicker from '@/components/atoms/AscDatePicker'
import AscNote from '@/components/atoms/AscNote'
import AscAutocompleteSelector from './AscAutocompleteSelector'
import AscLabel from '@/components/atoms/AscLabel'
import {
  getDateGivenOffset,
  getReportExportMinDate,
  getReportExportMaxDate,
} from '@/utilities/dates'

export default {
  name: 'AscFleetMessagesExport',

  components: {
    AscDatePicker,
    AscAutocompleteSelector,
    AscNote,
    AscLabel,
  },

  props: {
    value: {
      type: Object,
      default: null,
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    ataChapters: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      airlineIds:
        this.value && this.value.airlineIds
          ? this.value.airlineIds
          : this.airlines?.length === 1
          ? [this.airlines[0].value]
          : [],
      ataChapterIds:
        this.value && this.value.ataChapterIds ? this.value.ataChapterIds : [],
      dates:
        this.value && this.value.dates
          ? this.value.dates
          : {
              startDate: getDateGivenOffset(new Date(), -30),
              endDate: new Date(),
            },
      minDate: getReportExportMinDate(),
      maxDate: getReportExportMaxDate(),
    }
  },

  computed: {
    airlinesData() {
      return this.airlines
    },
    ataChaptersData() {
      return this.ataChapters
    },
  },

  mounted() {
    this.handleInput()
  },

  methods: {
    handleInput() {
      const data = {
        dates: {
          startDate:
            this.dates.startDate !== null ? this.dates.startDate : new Date(),
          endDate:
            this.dates.endDate !== null ? this.dates.endDate : new Date(),
        },
        airlineIds: this.airlineIds,
        ataChapterIds: this.ataChapterIds,
      }
      this.$emit('input', data)
    },
  },
}
</script>

<style lang="scss">
.asc-fleet-messages-export {
  padding: 0 10px;

  .asc-report-note {
    &.asc-note--container {
      background-color: $semantic-warning-hover;
    }

    .asc-note {
      display: flex;
    }

    &--icon {
      align-self: flex-start;
      padding: 6px 3px;
    }

    &--text {
      color: $primary-black;
      font-size: 12px;
      padding: 3px;
    }
  }

  .asc-empty-div {
    height: 30px;
  }

  .asc-datepicker-input--container {
    padding-top: 10px;

    .input-container .date-picker-field .v-label--active {
      font-size: 14px;
    }

    .v-input__slot {
      border-bottom: 2px solid $gray-300;
    }
  }
}
</style>
